<template lang="html">
  <div>
    <div v-if="isConsentReceived" class="consent-received d-flex align-item-center mb-10">
      <svgicon name="green-circle-tick" width="14" height="14" class="mr-5" :original="true" />
      <span>Consent received</span>
    </div>
    <div class="row track" v-if="showMap">
      <Spinner v-if="isMapLoading && isLoading" class="Loacationspinner"/>
      <iframe v-else-if="!isOrderLoading && !isMapLoading"
        :src="trackUrl" frameborder="0"
        style="border:0" width="100%" height="700px" title="SimTrack"/>  
    </div>
    <div v-else class="status-msg my-sm sm-height" text="bottom-right">
      <div class="status-content">
        <span class="status-inner mt-40">
          <img :src="NoLocation" width="300" class="img-responsive" alt=""/>
          <p style="width:120px">
            <span>{{errorStatus}}</span>
            <span v-if="operator">{{$t('INDENT_OPERATOR')}}: {{operator}}</span>
          </p>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import { LocationTracker, mapType } from 'pando-constants';
import NoLocation from '@common/asset/images/status-no-lanes.png';

export default {
  props: {
    order: {
      type: Object,
      default: () => {},
    },
    isOrderLoading: {
      type: Boolean,
      default: false,
    },
    isShipper: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    showMap: {
      type: Boolean,
      default: false,
    },
    operator: {
      type: String,
      default: '',
    },
    consentStatus: {
      type: String,
      default: '',
    },
    isMapLoading: {
      type: Boolean,
      default: false,
    },
    mapConfig: {
      type: Object,
      default: () => {},
    },
    environmentVariables: {
      type: Object,
      default: () => {},
    }
  },
  data() {
    return {
      NoLocation,
      data: null,
    };
  },
  created() {
    const tripId = !this.isOrderLoading &&
      (this.order.flow.sim_tracking && this.order.flow.sim_tracking.trip_id)
      || (this.order.flow.app_tracking && this.order.flow.app_tracking.track_trip_id);
    this.getconsent(this.order.driver.mobile, tripId);
  },
  computed: {
    trackUrl() {
      const tripId = !this.isOrderLoading && 
        (this.order.flow.sim_tracking && this.order.flow.sim_tracking.trip_id)
        || (this.order.flow.app_tracking && this.order.flow.app_tracking.track_trip_id);
      this.$session.set('tripId', tripId);
      return this.getUrl();
    },
    isConsentReceived() {
      const simTracking = this.order && this.order.flow && this.order.flow.sim_tracking;
      return !!(simTracking && simTracking.is_enabled && simTracking.trip_id
        && simTracking.trackable);
    },
    errorStatus() {
      let msg = this.consentStatus;
      switch (this.consentStatus) {
        case LocationTracker.PENDING_TRIP:
          msg = 'Consent not accepted';
          break;
        case LocationTracker.INVALID_TRIP:
          msg = 'Invalid/Unknown operator';
          break;
        default:
          break;
      }
      return msg;
    },
  },
  methods: {
    // TODO need to move common function
    getUrl() {
      let url = `${window.location.origin}/map`;
      if (this.mapConfig && this.mapConfig.type && this.mapConfig.type === mapType().HERE_MAP) {
        const apiKey = this.environmentVariables.hm_key;
        url = `${window.location.origin}/hereMap?apiKey=${apiKey}`;
      }
      return url;
    },
    async getconsent(phone, tripId) {
      this.$emit('getconsent', phone, tripId);
    },
  },
};
</script>

<style lang="scss">
@import "~@common/styles-shipper/settings";
.track {
    //border: 1px solid #E8E8E8;
    &-map {
        display: inline-block;
        float: left;
        &-list {
            display: inline-block;
            ul {
                padding-left: 0;
                margin: 0;
                @extend %list-unstyled;
                li {
                    padding: 10px;
                    width: 140px;
                    border-bottom: 1px solid #E8E8E8;
                    text-align: left;
                    a {
                        font-size: 1.2rem;
                        color: #6E6E6E;
                        letter-spacing: 0.3px;
                        text-decoration: none;
                        &.active {
                            color: #008AFF;
                        }
                    }
                }
            }
        }
    }
}
.error-container {
  padding: 20px;
  text-align: center;
}
.Loacationspinner{
  position: absolute;
  top: 25%;
  left: 50%;
  z-index: 1;
}
</style>
